module.exports = __webpack_public_path__ + "static/media/Shower.774da698.png";